import { connectFela } from '../../../dependencies';
import Header from './Header';
import * as styles from './Header.styles';

export default connectFela(styles)(Header);
